module.exports = __webpack_public_path__ + "static/media/logo.867c754e.svg";